import React, { Component } from 'react';
import { connect } from 'react-redux';

import { openNoteEditor } from 'PipeRouter';

import AddNoteOptionViews from './views';


class AddNoteOption extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return <AddNoteOptionViews { ...this.props } />;
  }
}


export default connect(null, {
  openNoteEditor
})(AddNoteOption);
